import { lazy, Suspense } from 'react'

const wrap = (Component) => {
    const Wrapper = () => (
        <Suspense fallback={<div style={{ padding: '40px', textAlign: 'center', color: '#aaa' }}>Loading...</div>}>
            <Component />
        </Suspense>
    )
    return <Wrapper />
}

const VendorDashboard      = lazy(() => import('../pages/VendorPortal/VendorDashboard.jsx'))
const VendorJobsInProgress = lazy(() => import('../pages/VendorPortal/VendorJobsInProgress.jsx'))
const VendorJobDetail      = lazy(() => import('../pages/VendorPortal/VendorJobDetail.jsx'))
const VendorJobOffers      = lazy(() => import('../pages/VendorPortal/VendorJobOffers.jsx'))
const VendorJobOfferDetail = lazy(() => import('../pages/VendorPortal/VendorJobOfferDetail.jsx'))
const VendorJobsCompleted  = lazy(() => import('../pages/VendorPortal/VendorJobsCompleted.jsx'))
const VendorInvoices       = lazy(() => import('../pages/VendorPortal/VendorInvoices.jsx'))
const VendorInvoiceCreate  = lazy(() => import('../pages/VendorPortal/VendorInvoiceCreate.jsx'))
const VendorProfile        = lazy(() => import('../pages/VendorPortal/VendorProfile.jsx'))

export const vendorRoutes = [
    { path: '/vendor',                   element: wrap(VendorDashboard),      enabled: true },
    { path: '/vendor/jobs/in-progress',  element: wrap(VendorJobsInProgress), enabled: true },
    { path: '/vendor/jobs/:id',          element: wrap(VendorJobDetail),      enabled: true },
    { path: '/vendor/jobs/offers',        element: wrap(VendorJobOffers),       enabled: true },
    { path: '/vendor/jobs/offers/:offerId', element: wrap(VendorJobOfferDetail), enabled: true },
    { path: '/vendor/jobs/completed',    element: wrap(VendorJobsCompleted),  enabled: true },
    { path: '/vendor/invoices',          element: wrap(VendorInvoices),       enabled: true },
    { path: '/vendor/invoices/create',   element: wrap(VendorInvoiceCreate),  enabled: true },
    { path: '/vendor/profile',           element: wrap(VendorProfile),        enabled: true },
]
